import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f923c976&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f923c976&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=f923c976&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f923c976",
  null
  
)

export default component.exports